import { Component } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";

import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

import { KeycloakService } from "keycloak-angular";

@Component({
  selector: "myqq-landing",
  templateUrl: "./landing.page.html",
  styleUrls: ["./landing.page.scss"],
})
export class LandingComponent {
  constructor(private router: Router, private keycloakSvc: KeycloakService) {}
  cdnHost = environment.cdnHost;
  whyMembershipLink = "/why-membership";
  blogLink = "https://www.dontdrivedirty.com/blog/";
  careerLink = "/jobs";

  zipcode = new FormControl("", [
    Validators.required,
    Validators.minLength(5),
    Validators.maxLength(5),
  ]);

  experiences = [
    {
      image: `${this.cdnHost}/img/LP_Experience_5.png`,
      thumbImage: `${this.cdnHost}/img/LP_Experience_5.png`,
      alt: "Smiling employee photo",
    },
    {
      image: `${this.cdnHost}/img/LP_Experience_3.png`,
      thumbImage: `${this.cdnHost}/img/LP_Experience_3.png`,
      alt: "Quackals mascot and store photo",
    },
    {
      image: `${this.cdnHost}/img/LP_Experience_2.png`,
      thumbImage: `${this.cdnHost}/img/LP_Experience_2.png`,
      alt: "Employee in car wash photo",
    },
    {
      image: `${this.cdnHost}/img/LP_Experience_1.png`,
      thumbImage: `${this.cdnHost}/img/LP_Experience_1.png`,
      alt: "Vacuum photo",
    },
    {
      image: `${this.cdnHost}/img/LP_Experience_7.png`,
      thumbImage: `${this.cdnHost}/img/LP_Experience_7.png`,
      alt: "Smiling employee photo",
    },
    {
      image: `${this.cdnHost}/img/LP_Experience_4.png`,
      thumbImage: `${this.cdnHost}/img/LP_Experience_4.png`,
      alt: "Car in car wash photo",
    },
    {
      image: `${this.cdnHost}/img/LP_Experience_6.png`,
      thumbImage: `${this.cdnHost}/img/LP_Experience_6.png`,
      alt: "Young fan photo",
    },
    {
      image: `${this.cdnHost}/img/LP_Experience_8.png`,
      thumbImage: `${this.cdnHost}/img/LP_Experience_8.png`,
      alt: "Quackals mascot in car wash photo",
    },
  ];
  reviews = [
    {
      text:
        "I had an amazing experience at Quick Quack car wash ! The staff was incredibly friendly and efficient. My car has never looked better - it's spotless inside and out. The attention to detail was impeccable, and the pricing was very reasonable for the quality of service provided. I will definitely be returning and highly recommend them to anyone looking for a top-notch car wash!",
      name: "Andrey Guerrero",
      rating: 5,
    },
    {
      text:
        "Very attentive to detail!!! I was very satisfied with my wash. Excellent customer service as well! Will definitely be purchasing a membership! Thank you !",
      name: "Jaylee S.",
      rating: 5,
    },
    {
      text:
        "Quick Quack carwash is phenomenal. Their customer service is second to none and always asking if you need anything extra. Huge recommendation to bring your vehicle here for a wash.",
      name: "Juan Gonzalez",
      rating: 5,
    },
    {
      text:
        "I love this place to wash my car. It make my life easy and the workers are very helpful and friendly!",
      name: "GG",
      rating: 5,
    },
  ];

  get isLoggedIn() {
    return this.keycloakSvc.isLoggedIn();
  }

  handleLocationsSearch() {
    this.router.navigate(["/locations"], {
      queryParams: { zipcode: this.zipcode.value },
    });
  }

  handlePlansSearch() {
    this.router.navigateByUrl(`/plans/${this.zipcode.value}`);
  }
}
